import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { DndContext, DragOverlay, useSensor, useSensors, pointerWithin } from '@dnd-kit/core';
import { arrayMove, SortableContext } from '@dnd-kit/sortable';

import ManagerUnitCard from '../../../../containers/dashboards/cards/create/ManagerUnitCard';
import PointerSensor from './PointerSensor';

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .add-unit {
    display: flex;
    background-color: #f7f6f4;
    margin: 10px;
    padding: 50px 25px 15px;
    height: 40vh;
    min-height: 360px;
    width: calc(50% - 22px);
    min-width: 632px;

    .add-unit-button-wrapper {
      border: solid 1px lightgray;
      width: 100%;
      height: 100%;

      .add-unit-button {
        width: 100%;
        height: 100%;
        font-size: 1.6rem;

        span {
          text-decoration: underline;
        }
      }
    }
  }
`;

const customCollisionDetectionAlgorithm = (args) => {
  const pointerCollisions = pointerWithin(args);

  if (pointerCollisions.length > 0) {
    return pointerCollisions;
  }

  return [];
};

const CreateUnitsContainer = ({ units, addUnit, showNotValidFields, setUnits }) => {
  const [activeId, setActiveId] = useState(null);

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragStart = useCallback((event) => {
    setActiveId(event.active.id);
  }, []);

  const handleDragOver = useCallback(
    (event) => {
      const { active, over } = event;

      if (over && active.id !== over.id) {
        const oldIndex = units.findIndex(({ id }) => active.id === id);
        const newIndex = units.findIndex(({ id }) => over.id === id);

        const moved = arrayMove(units, oldIndex, newIndex);

        setUnits(moved);
      }
    },
    [setUnits, units]
  );

  const handleDragCancel = useCallback(() => {
    setActiveId(null);
  }, []);

  return (
    <StyledContainer>
      <DndContext
        sensors={sensors}
        collisionDetection={customCollisionDetectionAlgorithm}
        onDragStart={handleDragStart}
        onDragEnd={handleDragCancel}
        onDragCancel={handleDragCancel}
        onDragOver={handleDragOver}
      >
        <SortableContext items={units} strategy={() => {}}>
          {units.map(({ id, isFullSize }) => (
            <ManagerUnitCard
              id={id}
              isFullSize={isFullSize}
              key={id}
              showNotValidFields={showNotValidFields}
            />
          ))}
        </SortableContext>
        <DragOverlay dropAnimation={null}>
          {activeId ? <ManagerUnitCard id={activeId} isFullSize /> : null}
        </DragOverlay>
      </DndContext>
      <div className="add-unit">
        <div className="add-unit-button-wrapper">
          <Button type="link" className="add-unit-button" onClick={addUnit}>
            Add item
          </Button>
        </div>
      </div>
    </StyledContainer>
  );
};

export default CreateUnitsContainer;
